import { ScienceProject } from '../types/interfaces' // dostosuj ścieżkę

export default [
  {
    name: 'Fizyka i technologia materiałów szklistych',
    description:
      'Materiały szkliste oparte o tlenki krzemu i fosforu stanowią fundament współczesnej optoelektroniki. Ich unikalna, bezpostaciowa struktura pozwala na szeroką modyfikację właściwości fizykochemicznych. W ramach działalności naukowej zajmuję się syntezą nowatorskich szkieł krzemianowo-fosforanowych oraz kompleksowym badaniem ich właściwości elektrycznych i optycznych, co ma kluczowe znaczenie dla projektowania nowej generacji światłowodów i czujników.',
    time: '2025+',
  },
  {
    name: 'Przewodnictwo jonowe w kompozytach szklisto-ceramicznych',
    description:
      'Kompozyty szklisto-ceramiczne wykazujące wysokie przewodnictwo jonowe (Li+, Na+, K+, O2-) są kluczowym elementem rewolucji w obszarze magazynowania i konwersji energii. Stanowią one bezpieczną alternatywę dla płynnych komponentów w bateriach nowej generacji (solid-state) oraz ogniwach paliwowych. Moje badania koncentrują się na optymalizacji transportu jonów w tych strukturach poprzez analizę ich mikrostruktury oraz pomiary impedancyjne.',
    time: '2025+',
  },
  {
    name: 'Modelowanie procesów jonowych',
    description:
      'Zastosowanie sztucznej inteligencji rewolucjonizuje współczesną inżynierię materiałową. Wykorzystanie sieci neuronowych i uczenia maszynowego (potencjałów ML) pozwala na symulowanie dynamiki molekularnej oraz transportu jonów w materiałach szklistych z dokładnością kwantową przy minimalnym koszcie obliczeniowym. Projekt obejmuje implementację algorytmów uczenia maszynowego do predykcji właściwości strukturalnych i dyfuzyjnych szkieł.',
    time: '2026+',
  },
  {
    name: 'Akceleratory i aparatura jądrowa',
    description:
      'Akceleratory to urządzenia służące do przyspieszania cząstek i emisji promieniowania. Znajdują one wiele zastosowań w przemyśle i badaniach naukowych, gdzie służą m.in. do implantacji jonów czy wykrywania defektów w materiałach. Wykorzystuje się je także w radioterapii nowotworów. Konstrukcja aparatury jądrowej wiąże się zarówno z wykorzystaniem elektroniki przemysłowej, jak i z poznaniem takich technik jak pompy jonowe, piece próżniowe i systemy chłodzenia hydraulicznego. W ramach praktyk poznałem budowę i możliwości akceleratorów oraz tworzyłem oprogramowanie pozwalające je kontrolować.',
    time: '2025',
    label: {
      text: 'Staż / Praktyki',
      color: '#00647D',
    },
  },
  {
    name: 'Przewodniki superjonowe',
    description:
      'Przewodniki superjonowe to materiały, które wykazują wysokie przewodnictwo jonowe, co czyni je obiecującymi dla zastosowań w bateriach i ogniwach paliwowych. W ramach mini-praktyk wakacyjnych w Centrum Zaawansowanych Materiałów i Technologii CEZAMAT, wyprodukowaliśmy próbki takich materiałów, a następnie zajęliśmy się badaniem ich właściwości takimi technikami jak np. dyfrakcja rentgenowska (XRD).',
    time: 'Wakacje 2024',
    label: {
      text: 'Projekt wakacyjny',
      color: '',
    },
  },
  {
    name: 'Szkło bizmutowe',
    description:
      'W ramach mini-praktyk wakacyjnych na Wydziale Fizyki Politechniki Warszawskiej, zajmowaliśmy się syntezą szkła bizmutowego oraz poznaniem właściwości materiałów o strukturze krystalicznej i amorficznej. Następnie dokonaliśmy badań jego właściwości elektrycznych, termicznych czy strukturalnych ze szczególnym naciskiem na przejścia fazowe, którym za pośrednictwem temperatury ten materiał ulega np. krystalizację.',
    time: 'Wakacje 2024',
    label: {
      text: 'Projekt wakacyjny',
      color: '',
    },
  },
] as ScienceProject[]
